import { Controller } from "@hotwired/stimulus"

// This controller handles Turbo Stream updates and initializes other controllers
export default class extends Controller {
  connect() {
    document.addEventListener("turbo:frame-load", this.handleTurboFrameLoad.bind(this))
    document.addEventListener("turbo:before-stream-render", this.handleBeforeStreamRender.bind(this))
  }

  disconnect() {
    document.removeEventListener("turbo:frame-load", this.handleTurboFrameLoad.bind(this))
    document.removeEventListener("turbo:before-stream-render", this.handleBeforeStreamRender.bind(this))
  }

  handleTurboFrameLoad(event) {
    // Call turboStreamUpdate on any collection controllers
    const collectionControllers = this.application.getControllerForElementAndIdentifier(
      document.querySelector("[data-controller~='collection']"),
      "collection"
    )
    
    if (collectionControllers) {
      collectionControllers.turboStreamUpdate()
    }
  }

  handleBeforeStreamRender(event) {
    // Add a callback to run after the stream render
    event.detail.newStream.addEventListener("turbo:before-render", (renderEvent) => {
      renderEvent.detail.render = (currentElement, newElement) => {
        // Default rendering
        currentElement.innerHTML = newElement.innerHTML
        
        // After render, initialize controllers
        setTimeout(() => {
          const collectionControllers = this.application.getControllerForElementAndIdentifier(
            document.querySelector("[data-controller~='collection']"),
            "collection"
          )
          
          if (collectionControllers) {
            collectionControllers.turboStreamUpdate()
          }
        }, 0)
      }
    })
  }
}
